const styles = theme => ({
  container: {
    borderRadius: '12px',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px',
  },
  header: {
    fontSize: '18px',
    fontWeight: 500,
    padding: '8px 0px',
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#838D98',
  },
  formContainer: {},
  switch: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  providerSelector: {
    marginBottom: '16px',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    marginLeft: '3px',
  },
  settingsContainer: {
    marginTop: '8px',
    maxWidth: '640px',
  },
  settingsTitle: {
    fontSize: '16px',
    fontWeight: 450,
    marginBottom: '16px',
  },
  settingsFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  presetHint: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#838D98',
    marginTop: '6px',
  },
  presetNote: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#838D98',
    marginTop: '4px',
  },
  settingsRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
  },
  saveButton: {
    marginTop: '16px',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    alignItems: 'center',
  },
  testEmailSuccess: {
    marginTop: '12px',
    fontSize: '14px',
    color: '#1B873F',
  },
  testEmailError: {
    marginTop: '12px',
    fontSize: '14px',
    color: '#D32F2F',
  },
  successAlert: {
    marginTop: '16px',
  },
  upgradeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    marginTop: '16px',
  },
  upgradeTitle: {
    marginBottom: '8px',
    fontWeight: 500,
  },
  upgradeDescription: {
    marginBottom: '16px',
    textAlign: 'center',
    color: '#666',
  },
  upgradeButton: {
    minWidth: '120px',
  },
  disabledContent: {
    opacity: 0.5,
    pointerEvents: 'none',
    transition: 'opacity 0.2s ease-in-out',
  },
})

export default styles
